module.exports = __webpack_public_path__ + "img/jian.7a534729.png";